import React from 'react';
import { Layout } from 'react-admin';
import Menu from './Menu';

const appLayout = props => <Layout
    {...props}
    menu={Menu}
/>;

export default appLayout;


// WEBPACK FOOTER //
// ./src/components/AppLayout.js